import OnboardingIcon from '@assets/icons/user-checked.svg?react'
import { breakpoints } from '@constants'
import { IsCollapsedMenu } from '@utils'
import cn from 'classnames'
import { useMerchantQry } from 'mmfintech-backend-api'
import { cleanupUnderscores, tr, useMatchMedia } from 'mmfintech-commons'
import { type ReactNode, useState } from 'react'
import ReactTooltip from 'react-tooltip'

import styles from './OnboardingBanner.module.scss'

type OnboardingBannerProps = {
  onClick?: () => void
  caption?: ReactNode
  title?: string
  subtext?: string
  waiting?: boolean
  tooltipCollapsed?: boolean
}

const OnboardingBannerInner = (props: OnboardingBannerProps) => {
  const { onClick, caption, title, subtext, waiting = false, tooltipCollapsed } = props

  const isMobile = useMatchMedia({ breakpoint: breakpoints.xl, prefix: 'max' })

  const [collapsed, setCollapsed] = useState<boolean>(false)

  const { merchant } = useMerchantQry()

  const formatStatus = (): string =>
    merchant?.onboardingStatus
      ? tr(
          `METADATA.SUMSUB_STATUS.${merchant.onboardingStatus}`,
          cleanupUnderscores(merchant.onboardingStatus.toLocaleLowerCase())
        )
      : ''

  return (
    <div
      className={cn(styles['onboarding-banner'], { collapsed, waiting })}
      onClick={onClick}
      data-test='onboarding-banner'
    >
      <IsCollapsedMenu setCollapsedMenu={setCollapsed} />

      <div className={styles['banner-content']}>
        <div className='icon' data-for='onboarding-banner-tooltip' data-tip={formatStatus()}>
          <OnboardingIcon />
        </div>
        <ReactTooltip
          id='onboarding-banner-tooltip'
          textColor='black'
          backgroundColor='white'
          effect='solid'
          className='custom-tool-tip-component'
          padding='8px 6px'
          place='right'
          disable={!tooltipCollapsed}
          aria-haspopup='true'
        />

        {(!collapsed || isMobile) && (
          <div className={cn(styles['banner-text'], { under_review: waiting })} title={title}>
            <span>{caption ? caption : formatStatus()}</span>
            {subtext || caption ? <div className={styles['banner-subtext']}>{subtext || formatStatus()}</div> : null}
          </div>
        )}
      </div>

      {(!collapsed || isMobile) && <div className={cn('dot', { waiting })} />}
    </div>
  )
}

export default OnboardingBannerInner
